module.exports = __webpack_public_path__ + "static/media/global-network.8e710044.png";